import { makeStyles } from '@material-ui/core'
import clsx from 'clsx'
import React from 'react'
import DisplayFormatedNumber from '../../../../../components/DisplayFormatedNumber'
import { NumberFormat } from '../../../../../config'

export type PayoutLabelProps = {
  value: number | string | React.ReactNode
  format: NumberFormat
  label: string
  classes?: {
    label?: string
    value?: string
  }
}

const PayoutLabel = ({ label, format, value, classes }: PayoutLabelProps) => {
  const internalClasses = useStyles()

  return (
    <div className={internalClasses.container}>
      <div className={clsx(internalClasses.label, internalClasses.text, classes?.label)}>{label}</div>
      <div className={clsx(internalClasses.text, classes?.value)}>
        {typeof value === 'number' ? <DisplayFormatedNumber value={value} format={format} /> : value}
      </div>
    </div>
  )
}

export default PayoutLabel

const useStyles = makeStyles({
  container: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
  },
  label: {
    marginRight: 32,
    fontFamily: 'Lato',
  },
  text: {
    fontFamily: 'Lato',
    fontWeight: 700,
    fontSize: '15px',
    lineHeight: '20px',
    letterSpacing: '0.25px',
    color: '#212121',
  },
})
